import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

const HeatmapOccupancyActionTypes = new AbstractApiActionTypes(
  "heatmapOccupancy"
);

export default HeatmapOccupancyActionTypes;
